import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "src/store";

import { addBatchSelection, selectPaneEditEnabled, setBatchMode } from "@devices/store";
import { License } from "@devices/types";
import { SecondaryButton } from "@shared/CustomButton";

export const MenuLicense = (props: License) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["sidepanels"]);
    const editEnabled = useSelector(selectPaneEditEnabled);

    const onMove = () => {
        dispatch(setBatchMode({ type: "move", entity: "license" }));
        dispatch(addBatchSelection(props.id));
    };

    return (
        <SecondaryButton
            onClick={onMove}
            disabled={editEnabled}
            tooltipProps={{ title: t("sidepanels:devicePanel.tooltip.moveToDifferentGroup") }}
        >
            <i className="fa-solid fa-arrow-right-arrow-left" />
        </SecondaryButton>
    );
};
